module.exports = __webpack_public_path__ + "img/DSC_7721.27030809.jpg";